export function titleList(list,i) {
    list.forEach(item => {
        item.isActive = false
      });
      list[i].isActive = true
}


// WEBPACK FOOTER //
// ./src/assets/js/global.js